import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';
import { AbsolutePseudo, focusProps } from '../../../theme/utils';

export const breadcrumbsTheme: ThemeOptions['components'] = {
  MuiBreadcrumbs: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .DS-Breadcrumb-root': {
          position: 'relative',
          ...theme.typography.P12R,
          color: tokens.theme.fg.action.linkNeutral,
          '&:hover:not(.Mui-disabled)': {
            textDecoration: 'underline',
            cursor: 'pointer',
            color: tokens.theme.fg.action.linkNeutralHover,
          },
          '&.Mui-disabled': {
            color: tokens.theme.disabled.fg,
          },
          '&:focus-visible': {
            outline: 'none',
            '&:after': {
              ...AbsolutePseudo,
              ...focusProps(),
              inset: -4,
              borderRadius: tokens.theme.radius.sm,
            },
          },
        },
      }),
      separator: ({ theme }) => ({
        ...theme.typography.P12R,
        color: tokens.theme.fg.action.linkNeutral,
      }),
    },
  },
};
